import { useCallback, useState } from "react"
import { validateAdminForm } from "../utils/validation/adminSignInvalidation"
import  {adminLoginService, AuthError}  from "../services/Admin/adminSignInService";
import { encryptField } from "../utils/encryption";
// Auth-2.3.4
import { useAdminAuth } from "../context/AdminAuthContext"

import { useNavigate } from "react-router-dom";
import { enqueueSnackbar } from "notistack";

export const useAdminSignIn = ()=>{
    const { loginSuccess } = useAdminAuth()
    // Val.1 in validation service page we have use object to show error hence useState defined as empty object
    const [errors, setErrors] = useState({});

    const [apiError, setApiError] = useState('')
    const [isLoading, setIsLoading] = useState(false)

    //Val2. we are going to submit the email, password and set to formadata
    const [formData, setFormData] = useState({
        email: "",
        password:"" 
    });

    const navigate = useNavigate();

    const [showPassword, setShowPassword] = useState(false)
    // val.6 validateSignIn Callback function update on every [formData] dependancy array chnage
    const validateSignIn = useCallback(()=>{
        /* // Add debounce to onChange for better performance referece for interview
-import { debounce } from "lodash"; */
        // val.3 stored the validation service and alignwith formData
        const inputErrors = validateAdminForm.adminSignInValidation(formData);
        // val.4 set all erros to display in input field
        setErrors(inputErrors);
        // val.5 errors are stored in objets hence to check it Object.keys or Object.entries are 0 (none) return without error
        return Object.keys(inputErrors).length === 0;
        // OR
        // return !Object.keys(inputErrors).length

    },[formData])

    // val.7 onChange when input[field] and input[value] change
    // val.8 on change execute when update depency [errors, formData]
    /* [The onChange function uses useCallback and has dependencies on errors and formData. This is acceptable, but note that on every change, we are updating the form and clearing the error for that field. , If you added formdata thats acceptable but Get lower Performance] */
    
    const onChange = useCallback((field, value)=>{
                
        // val.9 update the ...formData with previous value and current value
        setFormData( pre=>{
            const updatedFormData = {...pre, [field]:value};
            return updatedFormData            
        })
        // const updatedFormData = {...formData, [field]:value}
        // setFormData(updatedFormData);
        // val.10 while changing the input[field] (took array because erros are objects)
        if(errors[field]){
            // get previous and set to clear 
            setErrors((prev) =>({...prev, [field]: ""}))
        }
        // Clear server error on any input change
        if(apiError){
            setApiError('')
        }
    },[errors, apiError])
 
    const handleSubmit = useCallback( async (e)=>{
        if(e) e.preventDefault()
        // Clear previous server errors
        setApiError('')
        // Add rate limiting
        if (isLoading) return;

        // val.11 call the method on click or submit          
        const isValid = validateSignIn();
        // val.12 return if not valid
        if(!isValid) return;

        // Set loading to true when the request starts
        setIsLoading(true);        

        // After frontEnd validation Send reqest to apiEndpoint, Create service at adminSignInService check- Auth-2.0
            try {
                // Auth-2.5 get the api response and post the data of formData(email and pass) to the server, Stored into var to set token in localStoarege
                //[debounce protection - await]
                // console.log("🔄 Attempting login...");
                await adminLoginService.login(
                    formData.email,
                    formData.password
                );

                // console.log("✅ Login successful, fetching admin profile...");
                // ✅ Wait for loginSuccess to complete and get admin data
                const adminProfile = await loginSuccess();
                // console.log("✅ Admin profile fetched:", adminProfile);
    
                // 3. Show success message
                enqueueSnackbar(`Welcome back, ${adminProfile.name}!`, { 
                variant: 'success',
                autoHideDuration: 3000 
                });

               // Auth-2.6 while gettingt the reponse from server we should active the loading state true
                // setIsLoading(true)
                // console.log(adminData); 
                // Get the service from adminAuthService and store the var formDate there. Create the reusable service for Authenticaion set user token and others // Auth 3.0 check - adminAuthService;
                
                // Auth 3.2 set token with formdata
                // AdminAuthService.setAuthData(adminData) 
                // Navigate to DashBoard profile page (AdminPanel) Dash 4.0
                    // ✅ Navigate only after we have the admin profile
                    navigate('/admin-panel'); 
                // isSetL            
                
            } catch (error) {
                // Auth-2.8 handle the errors
                
                // Auth-2.3.5 error handling
                 // Handle different error types and set server error message 
                 let errorMessage = "Login failed. Please try again."               
                // setApiError(error.message)
                if(error instanceof AuthError){
                    if(error.fieldError){
                        setErrors((pre) => ({
                            ...pre,
                            [error.fieldError.field] : error.fieldError.message
                        }))
                        errorMessage = ''; // Don't show duplicate message
                    }else{
                        errorMessage = error.message; // Use the message from AuthError
                        // setApiError(error.message)
                    }

                }else{
                    errorMessage = error.message || "Login failed. Please try again.";                    
                }
                // Auth-2.3.6 error handling
                setApiError(errorMessage)
            }
            // Auth-2.9 after successfuly post request without catch erros setLoding false
            finally {
                setIsLoading(false)
            }        
            //val.13 update dependacy validateSignIn Auth-2.10 update formData dependancy P.4 add setloading dependancy
    },[validateSignIn, formData, isLoading, navigate, loginSuccess, enqueueSnackbar])

    const handleClickShowPassword = ()=>{
        setShowPassword(prev=> !prev)
    }

    return{
        errors,
        isLoading,
        onChange,
        handleSubmit,
        formData,
        handleClickShowPassword,
        showPassword,
        apiError
    }

}



